import Vue from "vue";
import Vuex from "vuex";
import API from "../services/apiservices";

// modular stores
import ambientesStore from "./ambientes";
import caixasaidaStore from "./caixasaida";
import clientesStore from "./clientes";
import consultasStore from "./consultas";
import consumidoresStore from "./consumidores";
import marcasStore from "./marcas";
import parempStore from "./paremp";
import profilerStore from "./profiler";
import representantesStore from "./representantes";
import tipospedidoStore from "./tipospedido";
import conferenciaStore from "./conferencia";
import barcodeStore from "./barcode";
import idiomasStore from "./idiomas";
import menusStore from "./menus";
import auditStore from "./audit";

// stores de páginas ...
import romaneiosStore from "../views/Transportadora/stores";

// json
import versions from "../assets/json/versions.json";

Vue.use(Vuex);

function getCookie(name) {
  let value = "; " + document.cookie;
  let parts = value.split("; " + name + "=");
  if (parts.length === 2) return parts.pop().split(";").shift();
}

var isLogged = getCookie("token") && getCookie("token") !== "" ? true : false;

export default new Vuex.Store({

  state: {
    homepage: "/",
    isLogged: isLogged,
    apiloading: 0,
    version: {
      major: 1,
      middle: 64, // versão quando cria telas ou opções novas ( grande impacto )
      min: 0, // melhorias e correções ( pequenos ajustes )
      history: versions
    },
    cliente: {
      codigo_cliente: 0,
      fantasia: "",
      api: null,
      data: []
    },
    repres: {
      codigo_repres: 0,
      fantasia: "",
      api: null,
      data: []
    },
    empresa: {
      codigo_empresa: 0,
      fantasia: "",
      api: null,
      data: []
    },
    screen: {
      width: 800,
      heigth: 600
    },
    homepageslides: [
      { src: "https://www.grupok1.com.br/Assets/img/Kappesberg.jpg", roles: [] },
      { src: "https://www.grupok1.com.br/Assets/img/UZ2.jpg", roles: [] },
      { src: "https://www.grupok1.com.br/Assets/img/Idelli.jpg", roles: [] },
      { src: "https://www.grupok1.com.br/Assets/img/MyHome.jpg", roles: [] },
      { src: "https://www.grupok1.com.br/Assets/img/CasaPoesia.jpg", roles: [] },
      { src: "https://www.grupok1.com.br/Assets/img/Bartzen.jpg", roles: [] },
      { src: "@assets/img/PaginaInicialPedidos.png", roles: ["BARTZENROLE"] },
    ],
    log: [],
    endpointrequests: [] //{ url: 'servicos/minhaapi/get', status: 200, datecaller: new Date() }
  },

  getters: {
    homepage: (state) => state.homepage,
    gtxisLogged: (state) => state.isLogged,
    devmode: () => process.env.NODE_ENV == "development",
    //gtxVersion: (state) => state.version.major + "." + state.version.middle + "." + state.version.min,
    gtxVersionLastHistory: () => versions[versions.length-1],
    gtxVersionLastHistoryTooltip: () => {
      const hist = versions[versions.length - 1];
      return `Versão: ${hist.version} de ${new Date(hist.updated).toLocaleDateString()}<br>Alterações:<br>»${hist.description.join("<br>»")}`;
    },
    gtxVersion: () => versions[versions.length-1].version,

    gtxResize: (state) => state.screen,
    gtxTableStaked: (state) => (minwidth = 800) => state.screen.width < minwidth,
    gtxAPILoading: (state) => state.apiloading,
    gtxAPILoadingShow: (state) => state.apiloading > 0,

    // essas stores são carregadas assim que o usuário efetuar login
    // para disponibilizar os dados que ele tem acesso
    // existe um controle de atualização para atualizar esses dados 
    // sempre que houver mudança ( necessita adicionar um trigger nas tabelas relacionadas )
    gtxStores: () => [
      {
        message: "Carregando Empresas",
        name: "parempStore",
        action: "actParempGet",
        getter: "gtxParemp",
        init: null, // data início da busca
        finish: null, // data final da busca
        source: null, // dados retornados da busca
        error: null, // erros ocorridos na busca
        done: 0, // flag de finalização
      },
      {
        message: "Carregando Marcas",
        name: "marcasStore",
        action: "actMarcasGet",
        getter: "gtxMarcas",
        init: null,
        finish: null,
        source: null,
        error: null,
        done: 0,
      },
      {
        message: "Carregando Tipos de pedidos",
        name: "tipospedidoStore",
        action: "actTipospedidoGet",
        getter: "gtxTipospedido",
        init: null,
        finish: null,
        source: null,
        error: null,
        done: 0,
      },
      {
        message: "Carregando Consumidores",
        name: "consumidoresStore",
        action: "actConsumidoresGet",
        getter: "gtxConsumidores",
        init: null,
        finish: null,
        source: null,
        error: null,
        done: 0,
      },
      {
        message: "Carregando Clientes",
        name: "clientesStore",
        action: "actClientesGet",
        getter: "gtxClientes",
        init: null,
        finish: null,
        source: null,
        error: null,
        done: 0,
      },
      {
        message: "Carregando Ambientes",
        name: "ambientesStore",
        action: "actAmbientesGet",
        getter: "gtxAmbientes",
        init: null,
        finish: null,
        source: null,
        error: null,
        done: 0,
      },
      {
        message: "Carregando Representantes",
        name: "representantesStore",
        action: "actRepresentantesGet",
        getter: "gtxRepresentantes",
        init: null,
        finish: null,
        source: null,
        error: null,
        done: 0,
      },
      {
        message: "Carregando Consultas",
        name: "consultasStore",
        action: "actConsultasGet",
        getter: "gtxConsultas",
        init: null, // data início da busca
        finish: null, // data final da busca
        source: null, // dados retornados da busca
        error: null, // erros ocorridos na busca
        done: 0, // flag de finalização
      },
      {
        message: "Carregando Menus",
        name: "menusStore",
        action: "actMenusGet",
        getter: "gtxMenus",
        init: null, // data início da busca
        finish: null, // data final da busca
        source: null, // dados retornados da busca
        error: null, // erros ocorridos na busca
        done: 0, // flag de finalização
      },
    ],
    gtxStoresDone(state, getters) {
      return getters.gtxStores.reduce((a, b) => a + b.done, 0);
    },
    gtxStoresError(state, getters) {
      return getters.gtxStoresDone == getters.gtxStores.length
        ? getters.gtxStores.filter((f) => f.error)
        : [];
    },

    gtxHistoryGet: (state) => state.version.history,
    gtxHistoryGetByVersion: (state, getters) => (version) => getters.gtxHistoryGet.find(f=>f.version == version),
    gtxHistoryGetByVersions: (state, getters) => getters.gtxHistoryGet.map(m=>({version: m.version})),
    gtxHistoryGetLastVersion: (state, getters) => getters.gtxHistoryGetByVersions[getters.gtxHistoryGetByVersions.length-1].version,

    gtxStoresNames: (state, getters) => getters.gtxStores.map(g => g.name),

    // cliente ...
    globalCliente: (state) => state.cliente,
    globalCliente_codigo_cliente: (state) => state.cliente.codigo_cliente,

    // repres ...
    globalRepres: (state) => state.repres,
    globalRepres_codigo_repres: (state) => state.repres.codigo_repres,

    // slides home page
    gtxHomePageSlides: (state) => (roles) => state.homepageslides.filter(f => f.roles.some(s => (roles || []).includes(s)) || f.roles.length == 0),

    // log
    gtxLog: (state) => state.log,
    gtxLogPage: (state) => (page) => state.log.find(f => f.page == page),

    // endpointrequests
    gtxEndpointRequests: (state) => state.endpointrequests,
    gtxEndpointRequestsGet: (state) => (url) => state.endpointrequests.find(f => f.url == url),
    gtxEndpointRequestsGetOk: (state) => (url) => {
      const endpoint = state.endpointrequests.find(f => f.url == url);
      let datenow = new Date();
      datenow = datenow.setMinutes(datenow.getMinutes() + 5);

      if (!endpoint) return false;

      if (endpoint.status == 200) {
        return true;
      } else {
        return (endpoint.datecaller > datenow);
      };
    },
  },

  mutations: {
    sethomepage: (state, homepage) => state.homepage = homepage,
    setisLogged: (state, isLogged) => state.isLogged = isLogged,
    setscreen: (state, screen) => state.screen = screen,
    setglobalcodigo_cliente: (state, codigo) => state.cliente.codigo_cliente = codigo,
    setcliente: (state, cliente) => (state.cliente = {cliente: {api: cliente.apiresponse, data: cliente.data, codigo_cliente: cliente.data.codigo_cliente, fantasia: cliente.data.fantasia}}),
    setrepres: (state, repres) => (state.repres = { repres: { api: repres.apiresponse, data: repres.data, codigo_repres: repres.data.codigo_repres, fantasia: repres.data.fantasia } }),
    setlog: (state, log) => {
      const index = state.log.findIndex(f => f.key == log.key);
      if (index == -1) {
        state.log.push(log);
      } else {
        state.log[index].data.push(log);
      }
    },
    setendpointrequests: (state, endpoint) => {
      const data = {
        url: endpoint.url,
        status: endpoint.status,
        datecaller: endpoint.datecaller || new Date()
      }

      const index = state.endpointrequests.findIndex(f => f.url == data.url);

      if (index == -1) {
        state.endpointrequests.push(data);
      } else {
        state.endpointrequests[index] = data;
      }
    },
    setAPILoading: (state, load) => {
      if (state.apiloading < 0) state.apiloading = 0;
      if (load) {
        state.apiloading++;
      } else {
        state.apiloading--;
      }
    },
    setAPILoadingReset: (state) => { 
      state.apiloading = 0;
    }
  },

  actions: {
    actHomePage({ commit }, homepage) {
      API.sethomepage(homepage);
      commit("sethomepage", homepage);
    },
    actisLogged({ commit }, isLogged) { commit("setisLogged", isLogged); },
    actScreenResize({ commit }, screen) {
      commit("setscreen", screen);
    },
    actReloadResources({ dispatch, getters }) {
      let r = {};
      getters.gtxStores.map((s) => {
        r = s;
        r.init = new Date().toTimeString().substring(0, 8);
        dispatch(r.name + '/' + r.action).then((res, rej) => {
          if (res) { }
          if (rej) { }
        });
        r.finish = new Date().toTimeString().substring(0, 8);
        r.done = 1;
      })
    },
    actGlobalSetCodigo_Empresa({ commit }, codigo) {
      commit('setglobalcodigo_cliente', codigo);
    },
    actLog({ commit }, data) {
      data = {...data, timestamp: new Date() };
      data = {...data, login: Vue.$cookies.get("lastlogin") };
      let log = { key: data.key, data: [] };
      log.data.push(data);
      commit('setlog', log);
    },
    actEndpointRequests({ commit }, data) {
      // console.log('actEndpointRequests: ', data);
      commit('setendpointrequests', data);
    },
    actAPIloading({ commit }, load) {
      // console.log('STORE::actAPIloading:', load);
      commit('setAPILoading', load);
    },
    actAPIloadingReset({ commit }) {
      commit('setAPILoadingReset');
    }
  },

  modules: {
    romaneiosStore,
    parempStore,
    marcasStore,
    tipospedidoStore,
    consumidoresStore,
    clientesStore,
    representantesStore,
    ambientesStore,
    caixasaidaStore,
    profilerStore,
    consultasStore,
    conferenciaStore,
    barcodeStore,
    idiomasStore,
    menusStore,
    auditStore,
  },

});
